import { getTextSchema } from './getSkill';

export default ({ preTag }) => {
  const document = { nodes: [{ match: { type: preTag }, min: 1, max: 1 }] };
  let blocks = {
    [preTag]: { ...getTextSchema() },
  };

  if (preTag === 'objective' || preTag === 'letter_body') {
    blocks = { object: 'block', type: 'paragraph', ...getTextSchema() };
  }

  return {
    document,
    blocks,
  };
};
